import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseApi } from '@kapi';
import { EnvironmentVariablesService } from '@kenv';
import { Promo } from '@kp/shared/components/promo/promo.model';
import { Constants } from '@kp/shared/constants.service';
import { DataStoreService } from '@kservice';
import { RequestType } from '@ktypes/enums';
import { DateTimeUtil } from '@kutil';
import { firstValueFrom, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class PromoApi extends BaseApi {
  constructor(
    client: HttpClient,
    dataStoreService: DataStoreService,
    environmentVariablesService: EnvironmentVariablesService
  ) {
    super(client, dataStoreService, environmentVariablesService);
  }

  getPromos(): Promise<Promo[]> {
    const params = {
      deviceCreatedTimestamp: DateTimeUtil.formatInLocal(),
      systemKey: Constants.dialogueSystemKey,
    };
    const request$ = this.performRequest<Promo[]>(RequestType.GET, this.buildUrl('/promos', true, params), {
      includeToken: true,
    }).pipe(
      map((response: HttpResponse<Promo[]>): Promo[] => response.body?.map((promo) => new Promo().deserialize(promo))),
      catchError((error) => {
        console.warn('Failed getting promos', error);
        return of(null);
      })
    );
    return firstValueFrom(request$).catch((error): null => {
      console.warn(`Error getting promos: `, error);
      return null;
    });
  }
}
